import { IResourceComponentsProps } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";
import Cw8Create from "components/cw8/Cw8Create";

export const SectionPubsCreate: React.FC<IResourceComponentsProps> = () => {
    // return <AntdInferencer />;

    const resourceName :string = 'sectionPub';
    return (
        <Cw8Create
            resourceName = {resourceName}
        ></Cw8Create>
    );

};
